import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import PageHeader1 from "../../components/common/PageHeader1";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import {
  GetQuestionListApi,
  handleDeleteQuestion,
} from "../../services/OnboardingQuestions";

function OnboardingQuestionList() {
  const navigate = useNavigate();
  const [ismodel, setIsModel] = useState(false);
  const [changeStatusTo, setChangeStatusTo] = useState({});
  const [getUserData, setgetUserData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [userList, setUserList] = useState([]);

  const { reset } = useForm();

  const columns = () => {
    return [
      {
        field: "sno",
        headerName: "S.No.",
        sortable: true,
        width: 100,
      },
      {
        field: "questionText",
        headerName: "Question Text",
        sortable: true,
        width: 250,
      },
      {
        field: "options",
        headerName: "Options",
        sortable: false,
        width: 300,
        renderCell: (params) => {
          const options = params.row.options || [];

          // 👉 Sirf option LABEL comma separated
          const labels = options
            .map((opt) =>
              typeof opt === "string" ? opt : opt.label
            )
            .filter(Boolean)
            .join(", ");

          return <span>{labels || "-"}</span>;
        },
      },
      {
        field: "action",
        headerName: "ACTION",
        sortable: false,
        width: 120,
        renderCell: (params) => (
          <div className="btn-group">
            {/* Edit */}
            <button
              type="button"
              className="btn btn-outline-primary btn-sm me-1"
              onClick={() =>
                navigate(`/add-onboarding-question/${params.row._id}`)
              }
            >
              <i className="icofont-ui-edit"></i>
            </button>

            {/* Delete */}
            <button
              type="button"
              className="btn btn-outline-danger btn-sm"
              onClick={() =>
                handleDeleteQuestion(params.row._id, getQuestionList)
              }
            >
              <i className="icofont-ui-delete"></i>
            </button>
          </div>
        ),
      },
    ];
  };

  async function getQuestionList() {
    setIsLoading(true);
    try {
      const response = await GetQuestionListApi();
      const { data } = response;

      setUserList(
        data?.map((item, i) => ({
          ...item,
          id: item?._id,
          sno: i + 1,
        })) || []
      );
    } catch (error) {
      console.error("Error fetching onboarding questions:", error);
    } finally {
      reset();
      setIsLoading(false);
    }
  }

  const clearData = () => {
    setgetUserData({});
    setChangeStatusTo({});
  };

  useEffect(() => {
    getQuestionList();
  }, []);

  return (
    <div className="body d-flex py-lg-3 py-md-2">
      <div className="container-xxl">
        <PageHeader1
          pagetitle="Onboarding Questions"
          modalbutton={() => (
            <div className="col-auto d-flex w-sm-100">
              <button
                type="button"
                className="btn btn-primary btn-set-task w-sm-100"
                onClick={() => navigate("/add-onboarding-question")}
              >
                <i className="icofont-plus-circle me-2 fs-6"></i>
                Add
              </button>
            </div>
          )}
        />

        <div className="row clearfix g-3">
          <div className="col-sm-12 mt-3">
            <div className="card">
              <div className="card-body">
                <DataGrid
                  rows={userList}
                  columns={columns()}
                  loading={isLoading}
                  pagination
                  initialState={{
                    pagination: { paginationModel: { pageSize: 8 } },
                  }}
                  pageSizeOptions={[8, 10, 25, { value: -1, label: "All" }]}
                  sx={{
                    border: "none",
                    "& .MuiDataGrid-root": { border: "none" },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal (unchanged) */}
      <Modal
        show={ismodel}
        onHide={() => {
          clearData();
          setIsModel(false);
        }}
        style={{ display: "block" }}
      >
        <Modal.Header closeButton>
          <h5 className="fw-bold">{changeStatusTo?.modelHeading}</h5>
        </Modal.Header>
        <Modal.Body>
          <h4 style={{ textAlign: "center" }}>
            Are you sure you want to change the status to{" "}
            {changeStatusTo.status}?
          </h4>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default OnboardingQuestionList;
